import { render, staticRenderFns } from "./InputMethodSelector.vue?vue&type=template&id=a106a478&scoped=true&"
import script from "./InputMethodSelector.vue?vue&type=script&lang=ts&"
export * from "./InputMethodSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a106a478",
  null
  
)

export default component.exports